import { useQuery, type UseQueryResult } from 'react-query';
import { getDailySessions } from '@hotjar/site';

/**
 * TODO: We're relying on the `getDailySessions` query function
 * if its contract in @hotjar/site package changes would break our query.
 * Once the churn deflection experiment ends we should change this query
 * by using our own API client.
 */
export function useDailySessions(siteId: string): UseQueryResult<number, Error> {
  return useQuery({
    queryKey: `daily-sessions-${siteId}`,
    queryFn: () => getDailySessions(Number(siteId)),
    staleTime: 60 * 60 * 1000,
    cacheTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
    select: (response) => response.sessions,
  });
}
